import React, {useState} from 'react';
import {Col, Flex, Row} from 'antd';
import Form from '../../components/data_entry/form/Form';
import InputFormField from '../../components/data_entry/form/InputFormField';
import CustomButton from '../../components/data_entry/Button';
import PasswordFields from '../../components/admin/PasswordFields';
import ENDPOINTS from '../../constants/endpoints';
import {BuildFieldErrorsDict} from '../../utils/utils';
import api from '../../services/api';
import {message} from 'antd';

export default function ShopChangePassword({onSuccess}) {
    const [form] = Form.useForm();
    const [submitLoading, setSubmitLoading] = useState(false);

    const onFinish = async ({password, confirm_password, old_password}) => {
        setSubmitLoading(true);
        try {
            await api.post(ENDPOINTS.AUTH_CHANGE_PASSWORD, {
                old_password,
                new_password: password,
                confirm_new_password: confirm_password,
            });
            message.success('Senha alterada com sucesso.');
            form.resetFields();
            onSuccess?.();
        } catch (error) {
            BuildFieldErrorsDict(error, form.setFields);
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <Form form={form} onFinish={onFinish}>
            <Row gutter={[16, 0]}>
                <Col xs={24}>
                    <InputFormField
                        type="password"
                        form={{
                            label: 'Senha atual',
                            name: 'old_password',
                            rules: [{required: true}],
                        }}
                    />
                </Col>
                <Col xs={24}>
                    <PasswordFields form={form}/>
                </Col>
                <Col xs={24}>
                    <Flex justify="end">
                        <CustomButton htmlType="submit" loading={submitLoading}>
                            Alterar senha
                        </CustomButton>
                    </Flex>
                </Col>
            </Row>
        </Form>
    );
}